import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';

export const drawerSections: IDynamicFormWidgetSection[] = [
  {
    inputs: {
      documentName: {
        name: 'documentName',
        title: 'Document Name',
        placeholder: 'Document Name',
        type: FormFieldType.text,
        value: '',
        required: true,
      },
      document: {
        name: 'document',
        title: 'Document',
        type: FormFieldType.fileUploader,
        value: '',
        required: true,
        disabled: false,
      },
    },
  },
];
